import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import pt from "./pt.json";

const noopLogger = {
  type: "logger",
  log: () => {},
  warn: () => {},
  error: () => {}
};

const i18n = i18next.createInstance();

if (!i18n.isInitialized) {
  i18n
    .use(noopLogger)                
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      debug: false,                
      interpolation: { escapeValue: false },
      resources: { en, pt },
      saveMissing: false,
      returnNull: false,
      returnEmptyString: false,
      missingKeyHandler: () => {},
      parseMissingKeyHandler: () => ""
    });
}

export default i18n;
